"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class NoValidSubscriptionExistsError extends client_library_1.ExtendableError {
    constructor() {
        super('NoValidSubscriptionExists');
    }
}
exports.default = NoValidSubscriptionExistsError;
//# sourceMappingURL=NoValidSubscriptionExistsError.js.map